import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import { Files, IFile, InboundDTO } from '@care-portals/api-interfaces';

import * as fromFile from './inbox.reducer';
import * as InboxSelectors from './inbox.selectors';
import * as InboxActions from './inbox.actions';
import { FileUploadFacade } from '../../common-components/file-upload/file-upload.component';

@Injectable()
export class InboxFacade implements FileUploadFacade {
  loading$ = this.store.pipe(select(InboxSelectors.getMessageLoading));
  uploading$ = this.store.pipe(select(InboxSelectors.getImageUploading));
  message$ = this.store.pipe(select(InboxSelectors.getSelected));
  messages$ = this.store.pipe(select(InboxSelectors.getMessages));
  files$ = this.store.pipe(select(InboxSelectors.getFiles));
  fileData$ = this.store.pipe(select(InboxSelectors.getFileData));
  fileItems$ = this.store.pipe(select(InboxSelectors.getFileItems));
  files: Files;

  constructor(private store: Store<fromFile.InboxPartialState>) {
    this.files$.subscribe(res => {
      this.files = res;
    });
  }

  loadMessages(filters: any = {}) {
    this.dispatch(InboxActions.loadMessages({ filters }));
  }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  getFile(fileName: string) {
    this.dispatch(InboxActions.getFile({ fileName }));
  }

  setRawFile(resourceId: string, fileItem: IFile) {
    this.store.dispatch(InboxActions.setRawFile({ resourceId, fileItem }));
  }

  uploadFiles(resourceIds: string[]) {
    const files: IFile[] = resourceIds.map(name => ({
      name,
      buffer: this.files[name].buffer,
      encoding: 'base64'
    }));
    this.dispatch(InboxActions.uploadFiles({ files }));
  }

  getMessage(id: string) {
    this.dispatch(InboxActions.getMessage({ id }));
  }

  replyMessage(inboundDto: InboundDTO, navigate: boolean = true) {
    this.dispatch(InboxActions.replyMessage({ inboundDto, navigate }));
  }
}
